
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { FileSpreadsheet } from 'lucide-react'
import { useState } from 'react'

import { useGenerateMonthlyInvoices } from '../hooks/useBilling'

interface GenerateInvoicesModalProps {
  isOpen: boolean
  onClose: () => void
}

export function GenerateInvoicesModal({ isOpen, onClose }: GenerateInvoicesModalProps) {
  const { mutate: generateMonthlyInvoices, isPending: isGenerating } = useGenerateMonthlyInvoices()
  const [generateMonth, setGenerateMonth] = useState(new Date().toISOString().slice(0, 7))

  const handleGenerateInvoices = () => {
    generateMonthlyInvoices(generateMonth, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Generate Monthly Invoices</CardTitle>
          <CardDescription>
            Automatically generate invoices for all active tenants
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Select Month *</Label>
            <Input
              type="month"
              value={generateMonth}
              onChange={(e) => setGenerateMonth(e.target.value)}
              required
            />
          </div>
          <div className="p-3 bg-slate-100 dark:bg-slate-800 rounded-lg">
            <p className="text-sm text-muted-foreground">
              This will generate invoices for all tenants with active billing plans.
              Existing invoices for this month will be skipped.
            </p>
          </div>
          <div className="flex gap-2 pt-4">
            <Button onClick={handleGenerateInvoices} disabled={isGenerating} className="gap-2">
              <FileSpreadsheet className="h-4 w-4" />
              {isGenerating ? 'Generating...' : 'Generate'}
            </Button>
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
